import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/ia', label: 'IA' },
    { path: '/seminaire', label: 'Séminaire' },
    { path: '/references', label: 'Références' },
    { path: '/articles', label: 'Articles' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav
        data-testid="main-navigation"
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white'
        }`}
      >
        <div className="container-main">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center" data-testid="nav-logo">
              <img
                src="https://customer-assets.emergentagent.com/job_cohen-services/artifacts/k2p7p6tm_WYCO%20fond%20blanc%20%281%29.jpg"
                alt="WYCO Management"
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-10">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                  className={`nav-link ${isActive(link.path) ? 'active text-[#0a1628]' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://www.linkedin.com/company/wyco-management/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-linkedin-btn"
                className="text-[#0a1628] hover:text-[#0077B5] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="mailto:yoann.cohen@wyco.fr"
                data-testid="nav-contact-btn"
                className="btn-primary"
              >
                Contact
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-btn"
              className="md:hidden p-2 text-[#0a1628]"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div data-testid="mobile-menu" className="mobile-menu">
          <button
            className="absolute top-6 right-6 p-2 text-[#0a1628]"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
          <div className="flex flex-col items-center space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                className={`mobile-menu-link ${isActive(link.path) ? 'text-[#BFA15F]' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://www.linkedin.com/company/wyco-management/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-linkedin-btn"
              className="flex items-center gap-2 text-[#0077B5] py-4"
            >
              <Linkedin size={24} />
              <span className="text-lg">LinkedIn</span>
            </a>
            <a
              href="mailto:yoann.cohen@wyco.fr"
              data-testid="mobile-contact-btn"
              className="btn-gold mt-8"
            >
              Contactez-moi
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;
